import React, { FC, useContext } from 'react';

import { Link, LockIcon, Tooltip } from '@smartshell/ui-kit';

import { LocalizationContext } from 'localization';

import s from './SettingsLock.module.scss';
export const SettingsLock: FC = () => {
  const { t } = useContext(LocalizationContext);

  return (
    <Tooltip
      contentClassName={s.tooltip_content}
      content={
        <div className={s.tooltip}>
          <span className={s.tooltip_text}>{t('settings.lock.title')}</span>
          <Link
            title={t('settings.lock.action')}
            link={'https://lk.smartshell.gg'}
          />
        </div>
      }
    >
      <div className={s.lock}>
        <LockIcon color="violet" size="s" />
      </div>
    </Tooltip>
  );
};
